export default __webpack_public_path__ + "static/media/loader-lexus.05224926.gif";